<p class="time" *ngIf="!isMessageTypeSame && !isTypeUser">
  {{ currentTimestamp | date : 'shortTime' }}
</p>
<div
  class="message"
  [ngClass]="{
    'message-type-user': isTypeUser,
    'message-type-va': !isTypeUser,
    'message-type-different': !isMessageTypeSame
  }"
>
  <ds-icon
    *ngIf="showIcon"
    size="24"
    [name]="iconName!"
    class="message-icon"
  ></ds-icon>
  <div>
    <div class="message-body" [innerHTML]="messageCopy"></div>
    <div *ngIf="links?.length" class="link-body">
      <span *ngFor="let link of links" class="message-links">
        <a ds-link (click)="onLinkClick($event, link)">{{ link.title }}</a>
      </span>
    </div>
  </div>
</div>
